import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogYoybuyGuide from "../pages/blog/yoybuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/yoybuy-spreadsheet-guide",
    element: <BlogYoybuyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;